import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { NoticesProvider } from '../../providers/notices/notices';
import { ToastProvider } from '../../providers/toast/toast';
import { UtilService } from '../../services/util';
import { TranslateService } from '@ngx-translate/core';
import { SanitizePipe } from '../../pipes/sanitize/sanitize';

@IonicPage()
@Component({
  selector: 'page-my-society',
  templateUrl: 'my-society.html',
})
export class MySocietyPage {

	notices = [];
  category = "COMMON";
  showData = false;
  selRegistrationLogin  : any;
  facilityGroup : any
  noticeCopyObj = []
  activeCategory = 'All'

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
    private noticeProvider: NoticesProvider, 
    private toast: ToastProvider,
    private util:UtilService,
    private sanitize:SanitizePipe,
  ) {

      this.selRegistrationLogin = localStorage.getItem('signup_login')

      if(this.selRegistrationLogin){
        this.showData = true
        this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
      }
else{
  noticeProvider.getConstant('FACILITY_STAFF_CATEGORY').then(val =>{
    if(val.status == 'success'){
    this.facilityGroup= val.data
    }
  });
  	noticeProvider.getNotices("COMMON").then(val => {
  		if(val.status == "success"){
  			this.notices = val.data;
  		} else{
  			toast.presentToast(val.message);
      }
      this.showData = true;
    });
  }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MySocietyPage');
  }

  changeCategory(category: string){
    if(this.selRegistrationLogin){
      this.showData = true
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
    }
else{
    this.category = category;
    this.notices = [];
    this.showData = false;
		this.noticeProvider.getNotices(category).then(val => {
  		if(val.status == "success"){
        this.notices = val.data;
        if(this.category == 'MEMBER'){
           this.notices.forEach((val)=>{
            val.contact = val.contact.split(",");
           })
           this.noticeCopyObj = this.notices
          this.sortMembers();
        }
  		} else{
  			this.toast.presentToast(val.message);
      }
      this.showData = true;
    });
  }
  }


  filterList(list,filterData){
    this.activeCategory = filterData
   if(filterData == 'All'){
     this.notices = this.noticeCopyObj
   }else{
   this.notices =  this.noticeCopyObj.filter(item => item.group == filterData)
   }
   console.log(this.notices)
  }

  sortMembers(){
    function compare(a,b){
      if(a.order < b.order)
        return -1;
      if(a.order > b.order)
        return 1;
      return 0;
    }

    this.notices.sort(compare); 

  }

  openUrl(url){
    this.util.openWithInAppBrowser(url);
  }

  getFileName(link: string){
    return link.slice(link.lastIndexOf('/')+1);
  }

  getObject(s : string){
  	return JSON.parse(s);
  }

}



// WEBPACK FOOTER //
// ./src/pages/my-society/my-society.ts